/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Fulfillments_Without_AckInputs */

const en_queue_fulfillments_without_ack = /** @type {(inputs: Queue_Fulfillments_Without_AckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Releases without ack`)
};

/**
* | output |
* | --- |
* | "Releases without ack" |
*
* @param {Queue_Fulfillments_Without_AckInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_fulfillments_without_ack = /** @type {((inputs?: Queue_Fulfillments_Without_AckInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Fulfillments_Without_AckInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_fulfillments_without_ack(inputs)
});